// extracted by mini-css-extract-plugin
export default {"savebtnclr":"chatBuilder_savebtnclr__5bkkB"};